(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('dispatchPlanningConsignment', {
        templateUrl: 'views/components/views/dispatchPlanningConsignment/dispatchPlanningConsignment.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'dispatchPlanningConsignmentService', 'ieScreenBlockService', 'printService', 'fileService', 'cargonizerApiService', 'logisticService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, dispatchPlanningConsignmentService, ieScreenBlockService, printService, fileService, cargonizerApiService, logisticService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let dispatchNo = $stateParams.dispatch_no

            let variableNames = {
                printer: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                createConsignmentEnabled: false,
                setting: {
                    dispatch_no: '',
                    case_count: '',
                    printer: '',
                    report_name: ''
                },
                selectListPrinters: [],
                itemsListOrderLines: [],
                itemsListCollis: [],
                creating: false,
                merging: false,
                splitting: false,
                printing: false,
                transferring: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting(){
                const info = (await dispatchPlanningConsignmentService.getSetting({ dispatch_no: dispatchNo }))[0];

                vm.model.setting = info;
                vm.model.setting.dispatch_no = dispatchNo;
                vm.model.setting.case_count = '1';

                loadList();
            }

            async function loadList() {
                if (vm.model.setting.consignment_keyno > 0) {
                    vm.model.itemsListCollis = await dispatchPlanningConsignmentService.listCollis({ dispatch_no: dispatchNo });
                } else {
                    dispatchPlanningConsignmentService.listOrderLines({ dispatch_no: dispatchNo }).then(function (list) {
                        vm.model.itemsListOrderLines = list;
                        vm.model.createConsignmentEnabled = true;

                        vm.model.itemsListOrderLines.forEach(function (item) {
                            if (item.item_stock_status === '0') {
                                vm.model.createConsignmentEnabled = false;
                            }
                        });
                    });
                }
            }

            async function retrieveReportSetting() {
                return dispatchPlanningConsignmentService.getReportSetting().then((response) => {
                    vm.model.setting.printer = response[0].printer_id;
                    vm.model.setting.report_name = response[0].report_name;
                });
            }

            async function loadPrinters() {
                const list = await logisticService.listCargonizerPrinters();

                vm.model.selectListPrinters = [];

                list.forEach((item) => {
                    item.item_id = item.item_cargonizer_printer_id;

                    if (item.item_name_sub1 > '') {
                        item.item_name = item.item_name + ' ' + '(' + item.item_name_sub1 + ')';
                    } else {
                        item.item_name = item.item_name;
                    }

                    vm.model.selectListPrinters.push(item);
                });

                return retrieveReportSetting();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'printer':
                            variableNames[key] = stateService.getCurrentName() + '.' + 'default_printer';
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'printer':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            var handleListToggle = function (item) {
                if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                } else {
                    item.item_is_selected = '1';
                }
            };

            // #region BUTTON CREATE CONSIGNMENT PROCEDURE FUNCTION CALL

            vm.createChanges = function () {
                vm.model.creating = true;

                dispatchPlanningConsignmentService.createConsignment({ dispatch_no: vm.model.setting.dispatch_no }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.creating = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.creating = false;
                        stateService.go('dispatchplanningconsignment', { dispatch_no: vm.model.setting.dispatch_no || 0 }, { reload: true, inherit: false });
                    }
                });
            };

            // #endregion BUTTON CREATE CONSIGNMENT PROCEDURE FUNCTION CALL

            vm.handleListClick = function (item) {
                // Toggle list status, but only inside else
                handleListToggle(item);
            };

            // #region BUTTON MERGE PROCEDURE FUNCTION CALL

            vm.mergeChanges = function () {
                vm.model.merging = true;

                dispatchPlanningConsignmentService.mergeCollis({ data: vm.model.itemsListCollis }).then(() => {
                    vm.model.merging = false;
                    loadList();
                }, () => vm.model.merging = false);
            };

            // #endregion BUTTON MERGE PROCEDURE FUNCTION CALL

            // #region BUTTON SPLIT PROCEDURE FUNCTION CALL

            vm.splitChanges = function () {
                vm.model.splitting = true;

                dispatchPlanningConsignmentService.splitCollis({ data: vm.model.itemsListCollis }).then(() => {
                    vm.model.splitting = false;
                    loadList();
                }, () => vm.model.splitting = false);
            };

            // #endregion BUTTON SPLIT PROCEDURE FUNCTION CALL

            // #region BUTTON TRANSFER PROCEDURE FUNCTION CALL

            vm.transferChanges = function () {
                vm.model.transferring = true;

                dispatchPlanningConsignmentService.transferConsignment({ consignment_keyno: vm.model.setting.consignment_keyno }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.transferring = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.transferring = false;
                        stateService.go('dispatchplanningconsignment', { dispatch_no: vm.model.setting.dispatch_no || 0 }, { reload: true, inherit: false });
                    }
                });
            };

            // #endregion BUTTON TRANSFER PROCEDURE FUNCTION CALL

            // #region PRINT CARGONIZER REPORT PROCEDURE FUNCTION CALL

            function printCargonizerReport(docarcFileName) {
                cargonizerApiService.printCargonizerConsignmentReport(0, vm.model.setting.printer, docarcFileName).then(function () {
                    ieScreenBlockService.stop();
                    stateService.go('dispatchplanningconsignment', { dispatch_no: dispatchNo || 0 },{ reload: true, inherit: false });
                });
            }

            // #endregion PRINT CARGONIZER REPORT PROCEDURE FUNCTION CALL

            // #region BUTTON PRINT PROCEDURE FUNCTION CALL

            vm.consolidateAndPrint = function () {
                vm.model.printing = true;
                let caseList = '';

                if (vm.model.itemsListCollis.length < 1) {
                    vm.model.printing = false;
                    return;
                }

                vm.model.itemsListCollis.forEach(function (item) {
                    if (item.item_is_selected == '1') {
                        if (caseList.length > 0) {
                            caseList = caseList + ',' + item.item_case;
                        } else {
                            caseList = item.item_case;
                        }
                    }
                });

                if (caseList.length > 0) {
                    ieScreenBlockService.start('message');
                    ieScreenBlockService.setMessage('Lager kolli');

                    printService.archive({
                        reportId: vm.model.setting.report_name,
                        parameters: {}
                    }).then(function (fileItem) {
                        vm.model.printing = false;
                        ieScreenBlockService.setMessage('Getting file details...');

                        fileService.getFileDetails({ fileName: fileItem.fileNameWithExtension, wait: true, instanceId: fileItem.instanceId }).then(function (dr) {
                            ieScreenBlockService.setMessage('Printing labels....');
                            printCargonizerReport(dr.fileName);
                        });
                    }, () => vm.model.printing = false);

                    setTimeout(() => {
                        ieScreenBlockService.stop();
                        stateService.go('dispatchplanningconsignment', { dispatch_no: dispatchNo || 0 }, { reload: true, inherit: false });
                    }, 1500);
                };
            };

            // #endregion BUTTON PRINT PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'printer':
                        if (utilityService.validateWatchValue(value, vm.model.setting.printer) !== true) return;

                        vm.model.setting.printer = value;

                        if (utilityService.validateParmsValue(vm.model.setting.printer, true) !== true) return;

                        rememberFunc('printer');
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                loadPrinters();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
